module.exports = __webpack_public_path__ + "img/info_general.84efaf1d.svg";